// extracted by mini-css-extract-plugin
module.exports = {"officeHours":"office-hours-module--office-hours--GkvG0","sectionDivider":"office-hours-module--section-divider--1v4yB"};